import {
  Typography,
  Grid
} from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

const NoRecord = () => {
  return (
    <Grid style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }}>
      <InboxOutlinedIcon
        style={{
          textAlign: 'center',
          fontSize: 30,
          opacity: 0.8,
        }}
      />
      <Typography
        style={{
          fontSize: '13px',
          margin: '0.4rem',
          textAlign: 'center',
        }}
        variant="body2"
      >
        No Records Found
      </Typography>
    </Grid>
  );
};

export default NoRecord;
